/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type SignatureSvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function SignatureSvgIcon(props: SignatureSvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlSpace={"preserve"}
      version={"1.1"}
      viewBox={"0 0 512 512"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <g fill={"currentColor"}>
        <path
          d={
            "M56.007 114.35c-5.535-5.539-14.51-5.539-20.045 0L4.148 146.159c-5.531 5.539-5.531 14.506 0 20.046l20.622 20.621 51.859-51.855zm230.415 282.273-17.68-69.546-51.858 51.863zm-28.286-80.148L86.058 144.397 34.2 196.26l172.073 172.077zM87.468 166.56l149.919 149.922-11.784 11.78L75.684 178.348zm108.194-34.069h29.356v28.017h-29.356zm0 68.202h29.356v28.009h-29.356zm61.028-68.202h173.056v28.017H256.69zm0 68.202h173.056v28.009H256.69zm31.908 68.201h141.148v28.01H288.598z"
          }
        ></path>

        <path
          d={
            "M429.817 11.059H195.582c-45.32 0-82.182 36.858-82.182 82.179v32.726l30.427 30.435V93.238c0-28.586 23.178-51.752 51.755-51.752h234.235c28.594 0 51.756 23.166 51.756 51.752V347.28h-80.097c-23.822 0-43.124 19.318-43.124 43.132v80.101h-162.77c-28.578 0-51.755-23.166-51.755-51.752v-37.072l-6.234-1.587 6.234-6.235v-22.202L113.4 321.239v97.522c0 45.313 36.862 82.179 82.182 82.179H370.95l8.917-8.913 123.224-123.224 8.909-8.912V93.238c0-45.321-36.862-82.179-82.183-82.179"
          }
        ></path>
      </g>
    </svg>
  );
}

export default SignatureSvgIcon;
/* prettier-ignore-end */
